// extracted by mini-css-extract-plugin
module.exports = {"advantages":"Sellers_advantages__3j5qq","advantagesItem":"Sellers_advantagesItem__25WRQ","advantagesItemEn":"Sellers_advantagesItemEn__lYnZb"};